import { Section } from "views/applications-id-report/components/Section";
import NoIncomeIcon from "shared/icons/noIncomeIcon.svg?react";
import { Applicant } from "types/application";
import { HousingAssistanceSlice } from "../slices/TablesSlice/HousingAssistanceSlice";
import { HousingAssistanceRecord, NoIncomeRecord } from "../types/income";

export const NoIncomeSection = ({
  noIncome,
  housingAssistance,
  applicant,
  verificationId
}: {
  noIncome?: NoIncomeRecord;
  housingAssistance?: HousingAssistanceRecord;
  applicant: Applicant;
  verificationId?: number;
}) => {
  return (
    <>
      <Section maxWidth="none" sectionTitle="Income summary">
        <div className="flex flex-col items-center gap-6 p-12">
          <div className="rounded-full bg-alpha-20 p-[30px]">
            <NoIncomeIcon className="text-content-400" />
          </div>
          <div className="space-y-2 text-center">
            <h3 className="font-bold text-base text-content-500">
              Applicant doesn&apos;t have income
            </h3>
            {noIncome?.additional_data.description ? (
              <p className="text-content-300">
                Current financial situation:{" "}
                {noIncome.additional_data.description}
              </p>
            ) : null}
          </div>
        </div>
      </Section>
      {housingAssistance ? (
        <HousingAssistanceSlice
          amountCents={housingAssistance.amount_cents}
          assets={housingAssistance.assets}
          incomeId={housingAssistance.id}
          applicant={applicant}
          verificationId={verificationId}
        />
      ) : null}
    </>
  );
};
